import firebase from 'firebase/app';
import 'firebase/firestore';

//functions
import { SaveSearchLastFive } from '../SetUpDefaultSearch/SetUpDefaultSearch';

export const AddOrg = async (company, newUser, id) => {
    await firebase
    .firestore()
    .collection("organizations")
    .doc(company)
    .collection("users")
    .where("role", "==", 'admin')
    .get()
    .then((querySnapshot) => {
            if(querySnapshot.docs.length > 0){
                // console.log("Document exists");
                userMembership(company, newUser)
            }else{
                // console.log("No such document!");
                userAdmin(company, newUser)
                teamToken(company, newUser, id)
            }
    })
    .catch((error) => {
        console.log("Error getting documents: ", error);
    })
    .then(()=>{
        signedOrg(company)
        SaveSearchLastFive(company, newUser, id)
        // checkForVProps(company)
    })
}

const userMembership = (company, newUser) => {

    const fullName = newUser.firstName + ' ' + newUser.lastName;

    firebase
        .firestore()
        .collection('organizations')
        .doc(company)
        .collection('users')
        .doc(fullName)
        .set({
            firstName: newUser.firstName,
            lastName: newUser.lastName,
            company: company,
            email: newUser.email,
            role: 'member'
        })
}

const userAdmin = (company, newUser) => {

    const fullName = newUser.firstName + ' ' + newUser.lastName;

    firebase
        .firestore()
        .collection('organizations')
        .doc(company)
        .collection('users')
        .doc(fullName)
        .set({
            firstName: newUser.firstName,
            lastName: newUser.lastName,
            company: company,
            email: newUser.email,
            role: 'admin',
            master: 'Yoda'
        })
}

const signedOrg = async (company) => {
    await firebase
        .firestore()
        .collection('allSignedOrg')
        .doc(company)
        .get()
        .then((doc) => {
            if (!doc.exists) {
                firebase
                .firestore()
                .collection('allSignedOrg')
                .doc(company)
                .set({
                    company: company
                })
            }
        }).catch((error) => {
            console.log("Error getting document:", error);
        });
}

const teamToken = (company, newUser, id) => {
    firebase
        .firestore()
        .collection('organizations')
        .doc(company)
        .collection('teamToken')
        .doc(company)
        .set({ 
            firstName: newUser.firstName,
            lastName: newUser.lastName,
            company: company,
            email: newUser.email,
            teamToken: false,
            adminId: id,   
        })
}